import { DatePickerDate } from './DatePicker'

export const getWeekOfMonth = (date: Date) => {
  let firstWeekday = new Date(date.getFullYear(), date.getMonth(), 1).getDay() - 1
  if (firstWeekday < 0) {
    firstWeekday = 6
  }
  const offsetDate = date.getDate() + firstWeekday - 1
  return Math.floor(offsetDate / 7)
}

export const buildMonthWeeks = (date: Date) => {
  const lastDayOfMonth = new Date(date.getFullYear(), date.getMonth()+1, 0).getDate()
  const monthDaysList = Array.from(Array(lastDayOfMonth).keys()).map(d => new Date(new Date(date).setDate(d +1)))
  const monthWeeks: Array<Array<DatePickerDate | null>> = []
  const today: Date = new Date()

  monthDaysList.forEach((day) => {
    const weekNumberOfMonth = getWeekOfMonth(day)

    //add week array if new week
    if(monthWeeks.length < weekNumberOfMonth + 1) {
      monthWeeks.push([])
    }

    const dateDiffDays = getDateDiffInDays(today, day)
    const isUsable: boolean = dateDiffDays >= 0 && dateDiffDays < 61 
    monthWeeks[weekNumberOfMonth].push({ date: day, isUsable })
  })

  //Add null for dates outside of month range for first week
  while(monthWeeks[0].length < 7) {
    monthWeeks[0].unshift(null)
  }

  //Add null for dates outside of month range for last week
  while(monthWeeks[monthWeeks.length -1].length < 7) {
    monthWeeks[monthWeeks.length -1].push(null)
  }

  return monthWeeks
}

const getDateDiffInDays = (d1: Date, d2: Date): number => {
  d1 = new Date(new Date(d1).setHours(0,0,0,0))
  d2 = new Date(new Date(d2).setHours(0,0,0,0))
  return Math.round((d1.getTime() - d2.getTime()) / 86400000) // Day in milliseconds: 86400000 = 1000 * 60 * 60 * 24
}

export const isToday = (date: Date) => {
  const today = new Date(new Date().setHours(0,0,0,0))
  const dateToCompare = new Date(new Date(date).setHours(0,0,0,0))
  return today.getTime() === dateToCompare.getTime()
}